import { AdData } from '@olxpwa-lib/utils-ad/types';

export const getMinimumStayParamFromAd = (ad: AdData | null) => {
    if (!ad) return null;
    return ad.params?.find(param => param.key === 'minimumstay');
};
